export function getEventMessageStream(chunkedStream, eventMarshaller) {
  var chunkReader = chunkedStream.getReader();
  var messageStream = new ReadableStream({
    start: function start(controller) {
      function push() {
        chunkReader.read().then(function (_a) {
          var _b, _c;

          var done = _a.done,
              value = _a.value;

          if (done) {
            controller.close();
            return;
          } // @ts-ignore: error TS2345: Argument of type 'Uint8Array | undefined'
          // is not assignable to parameter of type 'ArrayBufferView'


          var message = eventMarshaller.unmarshall(value);
          var messageType = message.headers[":message-type"].value;

          if (messageType === "error") {
            // Unmodeled exception in event
            var unmodeledError = new Error(message.headers[":error-message"].value || "UnknownError");
            unmodeledError.name = message.headers[":error-code"].value;
            controller.error(unmodeledError);
          } else if (messageType === "exception") {
            // throw this.exceptionsDeserializer(message);
            controller.enqueue((_b = {}, _b[message.headers[":exception-type"].value] = message, _b));
          } else if (messageType === "event") {
            controller.enqueue((_c = {}, _c[message.headers[":event-type"].value] = message, _c));
          } else {
            controller.error(new Error("Unrecognizable event type: " + message.headers[":event-type"].value));
          }

          push();
        });
      }

      push();
    }
  });
  return messageStream;
}